<ng-container [formGroup]="form">
    <fieldset 
        class="_mb-4"
        [ngClass]="modifierClassname">
        <label 
            [for]="fieldId"
            class="_inline-block _relative _ml-2 _mb-1"
            [class._required-field]="required"
            [ngClass]="darkTheme ? '_text-white' : '_text-black'">
            {{label}}
        </label>
        <div class="_input-squared _input-slim _px-2 _w-full _cursor-pointer _relative"
            tabindex="0"
            [ngClass]="{ '_input-dark' : darkTheme, '_min-w-60' : useMinWidth }"
            (click)="openDropdown($event)"
            (keydown)="openDropdown($event)"
            (blur)="isTouched()">
            <span *ngIf="selectedOption?.label || selectedOption?.value">{{ selectedOption.label || selectedOption?.value }}</span>
            <span *ngIf="!selectedOption" class="_text-transparency-black-50">{{ placeholderText }}</span>
            <input 
                tabindex="-1"
                [id]="fieldId"
                [formControlName]="fieldId"
                type="hidden">
            <span class="_absolute _h-full _w-4 _right-2 _top-0 _flex _justify-center _items-center">
                <i class="fa-sharp fa-light fa-chevron-down"></i>
            </span>
            <div *ngIf="showOptions" 
                [ngStyle]="{'max-height' : maxHeight}"
                class="_absolute _top-full _left-0 _bg-white _mt-nudge-2 _border _border-black _w-full _rounded-b _z-10 _overflow-y-auto _shadow">
                <div class="_pt-2 _pb-1 _px-2 _pointer-events-none _cursor-default _text-primary-1-tint-50">{{ placeholderText }}</div>
                <div *ngFor="let option of options" 
                    class="_py-1 _px-2 hover:_bg-primary-1-tint-10"
                    [ngClass]="{
                        '_pointer-events-none _text-primary-1-tint-50' : option.disabled,
                        '_cursor-pointer': !option.disabled,
                        '_bg-primary-1-tint-4 _pointer-events-none _cursor-auto' : option.label === selected || option.value === selected
                    }"
                    (click)="onSelect(option)">
                    {{ option.label || option.value }}
                </div>
            </div>
        </div>
        <div *ngIf="control.invalid && touched" class="_text-error-red-light _text-sm _mt-1 _ml-2">
            <div *ngIf="control.errors?.required">Field is required</div>
        </div>
    </fieldset>
</ng-container>
